import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad
{
    constructor(
        private _authService: AuthService,
        private _router: Router
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this._check();
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._check();
    }

    canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        return this._check();
    }

    _check(): Observable<boolean> {
        console.log('🔒 AuthGuard checking authentication...');
        console.log('  - accessToken exists:', !!this._authService.accessToken);
        console.log('  - isTokenExpired:', this._authService.isTokenExpired);
        
        // First check if token exists in localStorage and is valid
        if (this._authService.accessToken && !this._authService.isTokenExpired) {
            console.log('✅ AuthGuard: Token valid, allowing access');
            return of(true);
        }
        
        // If no token in memory, check Cognito session
        console.log('⚠️ No valid token in memory, checking Cognito session...');
        return new Observable(subscriber => {
            this._authService.getCurrentSession()
                .then(session => {
                    console.log('✅ AuthGuard: Cognito session found, allowing access');
                    // Save tokens to localStorage
                    this._authService.accessToken = session.accessToken.jwtToken;
                    this._authService.idToken = session.idToken.jwtToken;
                    this._authService.refreshToken = session.refreshToken.token;
                    this._authService.user = JSON.stringify(session.idToken.payload);
                    subscriber.next(true);
                    subscriber.complete();
                })
                .catch(error => {
                    console.log('❌ AuthGuard: No valid session, redirecting to login');
                    this._router.navigate(['/login']);
                    subscriber.next(false);
                    subscriber.complete();
                });
        });
    }

}
